export default __webpack_public_path__ + "static/media/folder.903bd64b.svg";